import { Pipe, PipeTransform } from '@angular/core';
import { OrderState } from '@app/shared/enums/OrderState.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'orderState',
    standalone: false
})
export class OrderStatePipe implements PipeTransform {
  public orderState = OrderState;
  public orderStatesList: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
   }

  getList() {
    this.orderStatesList = [];

    for (const [propertyKey, propertyValue] of Object.entries(OrderState)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.orderStatesList.push({ id: propertyValue, name: nameAndText, text: nameAndText });
    }

    return this.orderStatesList;
  }

  transform(value: any): string {
    if (value === null || value === undefined) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(OrderState).find(
          k => OrderState[k as keyof typeof OrderState] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }
}
